module.exports = __webpack_public_path__ + "img/tm.ea365f33.svg";